module.exports = __webpack_public_path__ + "static/media/keyword-in-image-file-name.1adb5cb2.svg";